<template>
  <div class="farmApp" :style="'height:'+curHeight+'px;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <!--<div class="search">
      <input type="text" v-model="keywork" placeholder="请输入关键词搜索"/>
      <button @click="search">搜索</button>
    </div>-->
    <div style="height:15px;"></div>
    <ul>
      <li v-for="(item,i) in farm" @click="toPush(item.id,'farmdetail')">
        <div class="img" :style="'background:url('+baseUrl+item.img+') no-repeat;background-size: 100% 100%'"></div>
        <div class="right">
          <h2>{{item.title}}</h2>
          <p>
            <span :style="item.status == 0 ? 'color:#FE8A17' : ''">{{item.status == 0 ? '未租' : '已租'}}</span>
            <font>{{item.address}}</font>
          </p>
          <div class="price">
            <i><b>¥</b> {{item.rate.split(".")[0]}}.<b>{{item.rate.split(".")[1]}}</b></i>
            <span>{{item.price}}</span>
          </div>
        </div>
      </li>
      
    </ul>
  </div>
</template>

<script> 
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        userData:[],
        baseUrl:'',
        code:'',
        keywork:'',
        bg:require('../../assets/images/farm.png'),
        farm:[]
      };
    },

    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/farm');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }else{
        this.userData = JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    mounted() {
      this.beforeMount();
      if(localStorage.getItem('userjwt') == null){
        this.login();
      }else{
        this.getFarm();
      }
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      search:function(){
        this.getFarm();
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },

      getFarm:function(){
        var that = this; 
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/farm/index',
          params:{
            keywork:that.keywork
          }
        }).then(function(response){
          var res = response.data.data;
          that.farm = res;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          that.userData = res.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .farmApp{
    max-width:640px;
    margin:0 auto;
    background:#ececec;
    background-size: 100% 100%;
    overflow-y: scroll;
  }

  .farmApp li{
    width:88%;
    display:block;
    background:rgba(255,255,255,.8);
    margin:0 auto;
    border-radius: 10px;
    padding:3%;
    margin-bottom:10px
  }
  .farmApp li:after,.farmApp li .right p:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }

  .farmApp li .img{
    float:left;
    width:35%;
    height:90px;
    border-radius: 8px;
    background-size: 100% 100%;
  }
  .farmApp li .right{
    float:left;
    width:65%
  }
  .farmApp li .right h2{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    color: #333333;
    font-size:15px;
    padding-left:8px
  }
  .farmApp li .right p{
    padding-left:8px;
    padding-top:14px;
  }
  .farmApp li .right p span{
    color:#00D138;
    font-size:15px;
    float:left;
  }
  .farmApp li .right p font{
    font-size: 15px;
    color: #999999;
    margin-left:15px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    float:left;
    width:75%
  }

  .farmApp li .right .price{
    padding-top:15px;
    padding-left:6px
  }
  .farmApp li .right .price span{
    text-decoration: line-through;
    color:#999;
    font-size:14px;
    padding-left:10px;
  }


  .farmApp li .right .price{
    font-size: 15px;
    font-family: PingFang SC;
    color: #333333;
  }
  .farmApp li .right .price i{
    color: #FF1E00;
    font-style:normal;
    font-size:16px;
    font-weight:bold;
    padding:0 4px;
  }
  .farmApp li .right .price b{
    font-size:12px;
  }

  .farmApp .search{
    position:fixed;
    width:100%;
    left:0;
    background:#f7faff;
    height:45px;
    top:0;
    z-index:99
  }
  .farmApp .search input{
    display:block;
    width:90%;
    height:35px;
    margin:0 auto;
    border:none;
    outline:none;
    padding:0 2%;
    font-size:15px;
    color:#333;
    border-radius:6px;
    margin-top:5px;
  }
  .farmApp .search button{
    position:absolute;
    top:5px;
    right:3%;
    z-index:33;
    height:35px;
    border:none;
    border-top-right-radius:6px;
    border-bottom-right-radius:6px;
    background:#00D138;
    font-size:15px;
    color:#fff;
    width:60px;
    outline:none;
  }
</style>